import { computed } from '@angular/core';
import { getDefaultFormalItems } from '@bizzdesign/modeler/utils-toolbar';
import {
  patchState,
  signalStore,
  withComputed,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { type MenuItem } from 'primeng/api';
import { distinctUntilChanged, pipe, tap } from 'rxjs';

type BDCoreState = {
  term: string;
  allOptions: MenuItem[];
};

const initialState: BDCoreState = {
  term: '',
  allOptions: getDefaultFormalItems(),
};

export const BDCoreLocalStore = signalStore(
  { protectedState: false },
  withState(initialState),
  withComputed(({ term, allOptions }) => ({
    filteredMenuItems: computed(() =>
      allOptions().filter((item) =>
        item.label?.toLowerCase().includes(term().toLowerCase()),
      ),
    ),
  })),
  withMethods((store) => {
    return {
      setArchiMateSearchTerm: rxMethod<string>(
        pipe(
          distinctUntilChanged(),
          tap((term) =>
            patchState(store, {
              term,
            }),
          ),
        ),
      ),
      resetValues: () => {
        patchState(store, {
          ...initialState,
        });
      },
    };
  }),
  withHooks({
    onDestroy({ resetValues }) {
      resetValues();
    },
  }),
);

export type BDCoreLocalStore = InstanceType<typeof BDCoreLocalStore>;
